// Add GST 

// console.log('[Price Update] z-custom.js script loaded');

function addGST(price){
  console.log('### addGST ###', typeof(price), typeof(price) == 'string')
  if ( typeof(price) == 'string' ){
    if (price.includes('$') || price.includes(',')){
      price = price.replace('$', '')
      price = price.replace(',', '')
      price = price * 100
    }
  }
  let priceText;
  // [[tax-modified-2025]] TEMP

    let gst = (price * 3) / 23;
    priceText = ( (price - gst) * 0.01).toFixed(2);

  // Laybuy updates (PDP only)
  if ($('.laybuy-money[data-money-convertible]').length > 0){
    updateLaybuyPrice(`$${(priceText/6).toFixed(2)}`)
  }

  priceText = numberWithCommas(priceText);;
  
  return '$' + priceText;
}

function numberWithCommas(x) {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x))
      x = x.replace(pattern, "$1,$2");
  return x;
}

// Format price with GST included (price is already in cents and includes GST)
function formatPriceIncGst(price) {
  if (typeof(price) == 'string') {
    if (price.includes('$') || price.includes(',')) {
      price = price.replace('$', '');
      price = price.replace(',', '');
      price = price * 100;
    }
  }
  // Price is in cents, convert to dollars and format
  let priceText = (price * 0.01).toFixed(2);
  priceText = numberWithCommas(priceText);
  return '$' + priceText;
}

function updateLaybuyPrice(price){
  $('.first-instalment-price .laybuy-money[data-money-convertible]').text(price)
}

$(document).ready(function() {
    // Function to check if element is available
    function checkElement() {
        if ($('.utils-compare-toggle__container').length) {
            // Element is available, trigger click event
            $('.utils-compare-toggle__container').trigger('click');
        } else {
            // Element not available yet, wait and check again
            setTimeout(checkElement, 100); // Check again in 100 milliseconds
        }
    }

    // Start checking for the element
    checkElement();
});


// // Track when items are added to the cart
// document.addEventListener('rebuy:cart.add', (event) => {
//   console.log('Item added to cart:', event.detail);
// });

// // Track when the cart is updated (items added, removed, or quantities changed)
// document.addEventListener('rebuy:cart.update', (event) => {
//   console.log('Cart updated:', event.detail);
//   const cartTotal = event.detail.cart.total_price;
//   console.log('Updated cart total:', cartTotal);
// });

// Track when the cart changes - general
document.addEventListener('rebuy:cart.change', (event) => {
  // console.log('Cart changed:', event);
  let cartSubTotal = (event.detail.cart.cart.total_price) * 0.01;
  
  let active_freegift = document.querySelector('.freegift-status .active_freegift').value;
  if (active_freegift){
    waitForElm('#rebuy-custom-code-block-header.freegift').then((elm) => {
      updateFreeGift(cartSubTotal);
      hideErrorPopup()
    });

  }
});

// // Track when items are removed from the cart
// document.addEventListener('rebuy:cart.remove', (event) => {
//   console.log('Item removed from cart:', event.detail);
// });

// // Track when the cart drawer opens
// document.addEventListener('rebuy:cart.open', (event) => {
//   console.log('Cart opened:', event.detail);
// });

// function waitForElm(selector) {
//   return new Promise(resolve => {if (document.querySelector(selector)) {return resolve(document.querySelector(selector));}const observer = new MutationObserver(mutations => {if (document.querySelector(selector)) {resolve(document.querySelector(selector));observer.disconnect();}});observer.observe(document.body, {childList: true,subtree: true});});
// }

function waitForElm(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }
    
    const observer = new MutationObserver((mutations) => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  });
}
function waitForClass(element, className) {
  return new Promise(resolve => {
    if (element.classList.contains(className)) {
      return resolve();
    }
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
          if (element.classList.contains(className)) {
            resolve();
            observer.disconnect();
          }
        }
      });
    });
    observer.observe(element, { attributes: true });
  });
}

function updateFreeGift(cartSubtotal) {
  console.log('## updateFreeGift', cartSubtotal)
  
  let container = document.querySelector('#rebuy-custom-code-block-header.freegift');
  if (!container) {
    console.log("Container #rebuy-custom-code-block-header.freegift not found");
    return;
  }

  if (cartSubtotal == 0){
    container.innerHTML = '';
    $('#rebuy-custom-code-block-header.freegift').removeClass('freegift_msg_appened');
    return;
  }
  
  let thresholds = Array.from(document.querySelectorAll('.freegift-status .threshold')).map(input => ({
    threshold: parseInt(input.value),
    title: input.dataset.pTitle,
    handle: input.dataset.pHandle
  }));

  thresholds.sort((a, b) => a.threshold - b.threshold);

  let freeGift = null;
  let nextThreshold = null;
  let amountNeeded = 0;

  for (let i = 0; i < thresholds.length; i++) {
    if (cartSubtotal >= thresholds[i].threshold) {
      freeGift = thresholds[i];
    } else {
      nextThreshold = thresholds[i];
      break;
    }
  }

  if (nextThreshold && nextThreshold.handle != '') {
    amountNeeded = nextThreshold.threshold - cartSubtotal;
    if(amountNeeded < 0) amountNeeded = 0;
  }

  let html = '';
  let freegift_msg = "You've unlocked a free gift: " //document.querySelector('.freegift-status .freegift_msg').value;

  if (nextThreshold) {
    amountNeeded = amountNeeded.toFixed(2)
    
    if (freeGift && Number(freeGift.threshold) === 0) {
      // No free gift yet
      tier_msg = `Spend $${amountNeeded} more and receive a free gift: ` // document.querySelector('.freegift-status .tier_msg').value;
    } else {
      // at least 1 free gift available
      let freegift_msg = "You've unlocked a free gift: " //document.querySelector('.freegift-status .freegift_msg').value;
      tier_msg = `Spend $${amountNeeded} more and upgrade your free gift to `
    }
    // tier_msg = tier_msg.replace('[price]', amountNeeded).replace(/\.$/, '');
  }

  if (freeGift && Number(freeGift.threshold) > 0) {
    html += `
      <div class="gift_wrap_confirmed">
        <h5 class="message">${freegift_msg}<a href="/products/${freeGift.handle}">${freeGift.title}</a></h5>
      </div>
    `;
  }

  if (nextThreshold && nextThreshold.handle != '') {
    html += `
      <div class="gift_wrap_target">
        <h5 class="message">${tier_msg}<a href="/products/${nextThreshold.handle}">${nextThreshold.title}</a></h5>
      </div>
    `;
  }

  container.innerHTML = ''
  container.innerHTML = html;
  $('#rebuy-custom-code-block-header.freegift').addClass('freegift_msg_appened');

}

async function hideErrorPopup() {
  let modal = await waitForElm('#rebuy-modal');
  // Then wait for the modal to have the 'is-visible' class
  await waitForClass(modal.querySelector('.rebuy-notification-modal'), 'is-visible');
  // Now check the error message and remove modal if applicable
  let errormsg = modal.querySelector('.rebuy-notification-dialog-header')?.textContent || '';
  if (errormsg.includes('updates parameter is invalid')) {
    modal.remove();
    document.body.classList.remove('rebuy-modal-visible');
    console.warn('Removed modal due to error message: updates parameter is invalid');
  }
}

// Update both GST-included and GST-excluded prices when variant changes (product page only)
function updateIncGstPrice(variant) {
  const priceSpanIncGst = document.querySelector('[data-product-price-inc-gst]');
  const priceSpanExclGst = document.querySelector('[data-product-price-excl-gst]');
  
  if (!priceSpanIncGst && !priceSpanExclGst) {
    console.log('[Price Update] Price spans not found in updateIncGstPrice');
    return;
  }
  
  // Only update on product pages (check for product pricing container)
  const productPricing = document.querySelector('[data-product-pricing]');
  if (!productPricing) return;
  
  if (variant && variant.price !== undefined) {
    // Update GST-included price
    if (priceSpanIncGst) {
      const formattedPriceIncGst = formatPriceIncGst(variant.price);
      priceSpanIncGst.textContent = formattedPriceIncGst;
      // console.log('[Price Update] Updated GST-included price to:', formattedPriceIncGst, 'from variant:', variant.id);
    }
    
    // Update GST-excluded price - need to find it again as theme may have replaced it
    // First try to find by our custom attribute
    let exclGstElement = document.querySelector('[data-product-price-excl-gst]');
    // If not found, try to find by data-price attribute (theme's selector)
    if (!exclGstElement) {
      exclGstElement = document.querySelector('[data-price-container] [data-price]');
    }
    
    if (exclGstElement) {
      if (variant.price == 0) {
        exclGstElement.textContent = 'Enquire for Price';
        // console.log('[Price Update] Updated GST-excluded price to: Enquire for Price');
      } else {
        const formattedPriceExclGst = addGST(variant.price);
        exclGstElement.textContent = formattedPriceExclGst;
        // console.log('[Price Update] Updated GST-excluded price to:', formattedPriceExclGst, 'from variant:', variant.id);
      }
    } else {
      console.log('[Price Update] GST-excluded price element not found');
    }
  } else {
    // Fallback: get variant ID from select and find price
    const variantSelect = document.querySelector('[data-variants]');
    if (!variantSelect) return;
    
    const variantId = variantSelect.value;
    if (!variantId || variantId === 'not-selected' || variantId === 'unavailable') return;
    
    // Try to get price from hidden data element
    const hiddenPriceElement = document.querySelector(`[data-price-inc-gst-hidden] [data-variant-id="${variantId}"]`);
    if (hiddenPriceElement) {
      const priceValue = hiddenPriceElement.getAttribute('data-price-value');
      
      if (priceSpanIncGst) {
        const formattedPriceIncGst = formatPriceIncGst(priceValue);
        priceSpanIncGst.textContent = formattedPriceIncGst;
      }
      
      if (priceSpanExclGst) {
        const formattedPriceExclGst = addGST(priceValue);
        priceSpanExclGst.textContent = formattedPriceExclGst;
      }
      return;
    }
    
    // Fallback: get price from variant select option
    const selectedOption = variantSelect.querySelector(`option[value="${variantId}"]`);
    if (selectedOption) {
      // Extract price from option text (format: "Variant Title - $X,XXX.XX")
      const optionText = selectedOption.textContent;
      const priceMatch = optionText.match(/\$[\d,]+\.?\d*/);
      if (priceMatch) {
        let variantPrice = priceMatch[0].replace(/[^0-9.]/g, '');
        variantPrice = parseFloat(variantPrice) * 100; // Convert to cents
        
        if (priceSpanIncGst) {
          const formattedPriceIncGst = formatPriceIncGst(variantPrice);
          priceSpanIncGst.textContent = formattedPriceIncGst;
        }
        
        if (priceSpanExclGst) {
          const formattedPriceExclGst = addGST(variantPrice);
          priceSpanExclGst.textContent = formattedPriceExclGst;
        }
      }
    }
  }
}

// Track if listeners are already set up
let variantPriceListenersSetup = false;

// Update both GST-included and GST-excluded prices when variant changes - set up listeners
function setupVariantPriceUpdate() {
  // Prevent duplicate listeners
  if (variantPriceListenersSetup) return;
  
  // Only run on product pages
  const productPricing = document.querySelector('[data-product-pricing]');
  if (!productPricing) {
    console.log('[Price Update] Not a product page');
    return;
  }
  
  const priceSpanIncGst = document.querySelector('[data-product-price-inc-gst]');
  const priceSpanExclGst = document.querySelector('[data-product-price-excl-gst]');
  
  if (!priceSpanIncGst && !priceSpanExclGst) {
    console.log('[Price Update] Price spans not found');
    return;
  }
  
  // Find the variant-selection element
  const variantSelection = document.querySelector('[data-variant-selection]');
  if (!variantSelection) {
    console.log('[Price Update] Variant selection not found');
    return;
  }
  
  // Listen for variant-change events directly on the variant-selection element
  variantSelection.addEventListener('variant-change', function(event) {
    console.log('[Price Update] Variant change event received', event.detail);
    if (event.detail && event.detail.variant) {
      // Wait a bit for theme's _updatePrice to finish, then update our prices
      setTimeout(function() {
        updateIncGstPrice(event.detail.variant);
      }, 50);
    } else {
      console.log('[Price Update] No variant in event detail');
    }
  });
  
  // Also watch for changes to the price container (theme replaces innerHTML)
  const priceContainer = document.querySelector('[data-price-container]');
  if (priceContainer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Price container was updated, find the variant and update our prices
          setTimeout(function() {
            const variantSelection = document.querySelector('[data-variant-selection]');
            if (variantSelection && variantSelection.getVariant) {
              variantSelection.getVariant().then(function(variant) {
                if (variant) {
                  updateIncGstPrice(variant);
                }
              });
            }
          }, 10);
        }
      });
    });
    
    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Mark as set up
  variantPriceListenersSetup = true;
  console.log('[Price Update] Listeners set up successfully');
  
  // Initial update on page load
  if (variantSelection.getVariant) {
    variantSelection.getVariant().then(function(variant) {
      if (variant) {
        updateIncGstPrice(variant);
      }
    });
  }
}

// Wait for DOM and variant-selection element to be ready
function initVariantPriceUpdate() {
  console.log('[Price Update] Initializing...');
  
  // Try to set up immediately
  setupVariantPriceUpdate();
  
  // Also try after a short delay in case element isn't ready yet
  setTimeout(function() {
    console.log('[Price Update] Retry attempt 1');
    setupVariantPriceUpdate();
  }, 500);
  
  // Also try after a longer delay
  setTimeout(function() {
    console.log('[Price Update] Retry attempt 2');
    setupVariantPriceUpdate();
  }, 1500);
  
  // Also try after even longer delay (theme JS might load late)
  setTimeout(function() {
    console.log('[Price Update] Retry attempt 3');
    setupVariantPriceUpdate();
  }, 3000);
  
  // Also try when variant-selection element is added to DOM
  const observer = new MutationObserver(function(mutations) {
    if (!variantPriceListenersSetup) {
      // console.log('[Price Update] MutationObserver triggered');
      setupVariantPriceUpdate();
      if (variantPriceListenersSetup) {
        observer.disconnect();
        console.log('[Price Update] Observer disconnected after success');
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Disconnect observer after 10 seconds to prevent memory leaks
  setTimeout(function() {
    observer.disconnect();
    if (!variantPriceListenersSetup) {
      console.log('[Price Update] Observer disconnected after timeout - setup may have failed');
    }
  }, 10000);
}

// Run initialization immediately and on various events
console.log('[Price Update] Setting up initialization...');

// Try immediately
setTimeout(function() {
  initVariantPriceUpdate();
}, 100);

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[Price Update] DOMContentLoaded fired');
    initVariantPriceUpdate();
  });
} else {
  // DOM is already ready
  console.log('[Price Update] DOM already ready');
  initVariantPriceUpdate();
}

// Also try when window loads (after all scripts)
window.addEventListener('load', function() {
  console.log('[Price Update] Window loaded, trying setup again');
  setTimeout(function() {
    setupVariantPriceUpdate();
  }, 500);
});